import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { AccountNavLink } from './account-nav-link';
import { AccountState, useAccounts, useBudgetId } from '@liquidbudget/common';

export const AccountNavArchived = () => {
  const budgetId = useBudgetId();
  const accounts = useAccounts();

  const archivedAccounts = accounts.filter((account) => account.state === AccountState.ARCHIVED);

  if (archivedAccounts.length === 0) {
    return null;
  }

  return (
    <AccordionItem value="archived" className="border-0">
      <AccordionTrigger className="py-2 px-2 pl-4 text-sm font-semibold hover:no-underline w-full">
        <div className="flex justify-between items-center w-full">
          <span className="text-muted-foreground pl-2">Archived</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <div className="flex flex-col space-y-0">
          {archivedAccounts.map((account) => (
            <AccountNavLink
              account={account}
              key={account.id}
              to={`/budget/${budgetId}/account/${account.id}`}
              text={account.name}
            />
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
